import {LocalizedContentValues} from '../types/GeneralSettingsFormValues';

interface LocalizedContentEntry {
  language: string;
  titleExtension: string | null;
  description: string | null;
}

export function buildLocalizedContentDefaults(
  enabledLanguages: string[],
  localizedData: Array<LocalizedContentEntry> | undefined
): Record<string, LocalizedContentValues> {
  const result: Record<string, LocalizedContentValues> = {};
  for (const lang of enabledLanguages) {
    const existing = localizedData?.find((item) => item.language === lang);
    result[lang] = {
      titleExtension: existing?.titleExtension ?? null,
      description: existing?.description ?? null,
    };
  }
  return result;
}
